import { Reducer } from 'redux'
import _ from 'lodash'
import { UserChat } from './types'
import * as actions from './actions'

export type UserchatState = Readonly<{
  userchats: Record<string, UserChat>
  count: number
  isLoading: boolean
}>

export const initState: UserchatState = {
  userchats: {},
  count: 0,
  isLoading: false
}

export const userChatReducer: Reducer<UserchatState, actions.UserChatActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_USER_CHATS_SUCCESS:
      return {
        ...state,
        userchats: { ..._.keyBy(action.payload.data, 'id') },
        count: action.payload.count
      }
    default:
      return state
  }
}
